import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Transaction_Type_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_TXNTYPE_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'TXN Type WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    TXNTYPE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'TXN Type Id', columnResourceName: 'colTxnTypeId', alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    TXNTYPE_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    WB_FK_ROW_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'FK Row ID', columnResourceName: 'colFKRowID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 100}},
    SOURCE_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source ID', columnResourceName: 'colSourceID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}}
}

var TransactionTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_TXNTYPE_ID',
        id_ui: 'TXNTYPE_ID',
        name:  'TXNTYPE_NAME'},


    searchProviderFields: vUI_Transaction_Type_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Transaction_Type_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var TransactionTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "TransactionTypeSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'TXNTYPE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'TXNTYPE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'TXNTYPE_ID','TXNTYPE_NAME','WB_FK_ROW_ID','SOURCE_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: TransactionTypeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var TransactionTypeSearch: ISearch = {
    searchName: "Find Transaction Type",
    renderOptions: { ui5ResourceId: "TransactionTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [TransactionTypeSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("TransactionTypeBO", "TransactionType", TransactionTypeSearch, "Transaction Type Search")

export {TransactionTypeSearch}